export const updatePlan = (plan: string) => {
  const updatedValue = plan.replace(
    /(free-trial)|(free)|(ultimate)|(basic)|(pro)|(plus)|(hobby)|(freemium)|(business)/gi,
    'professional'
  );

  return plan === 'professional' ? plan : updatedValue;
};
